import { withAuth } from '../../../../Auth/components'
import ActivatePromo from './ActivatePromo'

export default withAuth(ActivatePromo)
